import Feedback from '@betahuhn/feedback-js'
import {isDarkThemeEnabled} from "@/helpers/darkThemeHelper";

export function initFeedback(settings) {

    let background = '#858380'
    let primary = '#ffffff'
    let color = '#fff'
    // if (isDarkThemeEnabled()) {
    //     primary = '#000000'
    //     background = '#fff'
    //     color = '#000000'
    // }

    const types = {}
    if(settings.FeedbackTypeGeneral) {
        types.general = {
            text: 'Algemene feedback',
            icon: '<span class="fas fa-exclamation-triangle"></span>'
        }
    }
    if(settings.FeedbackTypeIdeas) {
        types.idea = {
            text: 'Ik heb een idee',
            icon: '<span class="fa fa-lightbulb"></span>'
        }
    }
    if(settings.FeedbackTypeBugs) {
        types.bug = {
            text: 'Ik heb een bug gevonden',
            icon: '<span class="fas fa-bug"></span>'
        }
    }

    new Feedback({
        id: 'feedback',
        endpoint: window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/feedback',
        events: false,
        emailField: true,
        forceShowButton: false,
        btnTitle: 'Feedback',
        title: 'Feedback',
        typeMessage: '',
        // contactLink: '',
        // typeMessage: '',
        success: 'Bedankt! 👊',
        inputPlaceholder: 'Vul hier je feedback in',
        emailPlaceholder: 'Email address (optioneel)',
        submitText: 'Versturen',
        backText: 'Terug',
        failedTitle: 'Oeps, er is een error opgetreden!',
        failedMessage: 'Probeer alsjeblieft opnieuw. Als het blijft gebeuren, stuur dan een e-mail naar ons toe.',
        position: 'right',
        primary: primary,
        background:background,
        color: color,
        types: types
    }).renderButton()
}
